(function () {
  'use strict';

  var SUBRATE = 0.15;
  var CAD = {
    1: 'every month',
    3: 'every 2 months',
    5: 'every 3 months'
  };

  function money(cents) {
    var n = (Math.round(cents) / 100).toFixed(2);
    return '$' + n;
  }

  function init(root) {
    if (!root || root.getAttribute('data-hb-sub01-ready')) return;
    root.setAttribute('data-hb-sub01-ready', '1');

    var opts = root.querySelectorAll('.opt');
    var sub = root.querySelector('.hb-sub01-refill');
    var subtxt = root.querySelector('.subtxt');
    var atc = root.querySelector('.atc');
    var p2pRoot = root.closest('[data-hb-p2p-buy]');
    if (!opts.length || !sub || !atc) return;

    function selectedOpt() {
      return root.querySelector('.opt.sel') || opts[0];
    }

    function selectedQty() {
      var s = selectedOpt();
      return s ? s.getAttribute('data-qty') : '3';
    }

    function refreshCadence() {
      if (!subtxt) return;
      subtxt.textContent =
        'Shipped ' + (CAD[selectedQty()] || 'on schedule') + '. No commitment. Pause, skip or cancel anytime.';
    }

    function renderPrices() {
      var on = sub.classList.contains('on');
      opts.forEach(function (o) {
        var qty = parseInt(o.getAttribute('data-qty'), 10) || 1;
        var one = parseInt(o.getAttribute('data-one'), 10) || 0;
        var rrpA = o.getAttribute('data-rrp');
        var rrp = rrpA ? parseInt(rrpA, 10) : null;
        var now = on ? Math.round(one * (1 - SUBRATE)) : one;
        var was = on ? (rrp != null ? rrp : one) : rrp;
        var ea = o.querySelector('.ea');
        var nowEl = o.querySelector('.now');
        var wasEl = o.querySelector('.was');
        var svEl = o.querySelector('.sv');
        if (ea) ea.textContent = money(Math.round(now / qty)) + '/tube';
        if (nowEl) nowEl.textContent = money(now);
        if (was != null && was > now) {
          if (wasEl) {
            wasEl.textContent = money(was);
            wasEl.classList.add('show');
          }
          if (svEl) {
            svEl.textContent = 'SAVE ' + Math.round(100 * (1 - now / was)) + '%';
            svEl.classList.add('show');
          }
        } else {
          if (wasEl) {
            wasEl.textContent = '';
            wasEl.classList.remove('show');
          }
          if (svEl) {
            svEl.classList.remove('show');
            svEl.textContent = '';
          }
        }
      });
      if (p2pRoot) {
        var sel = root.querySelector('.opt.sel');
        if (sel) {
          var q = sel.getAttribute('data-qty');
          var lbl = p2pRoot.querySelector('[data-sc-lbl]');
          var sn = p2pRoot.querySelector('[data-sc-now]');
          var sw = p2pRoot.querySelector('[data-sc-was]');
          if (lbl) lbl.textContent = q === '1' ? '1 Tube' : q + ' Tubes';
          var nowEl = sel.querySelector('.now');
          var wasEl2 = sel.querySelector('.was');
          if (sn && nowEl) sn.textContent = nowEl.textContent;
          if (sw) {
            if (wasEl2 && wasEl2.classList.contains('show')) {
              sw.textContent = wasEl2.textContent;
              sw.hidden = false;
            } else {
              sw.textContent = '';
              sw.hidden = true;
            }
          }
        }
      }
    }

    opts.forEach(function (o) {
      o.addEventListener('click', function () {
        opts.forEach(function (x) {
          x.classList.remove('sel');
        });
        o.classList.add('sel');
        refreshCadence();
        renderPrices();
      });
    });

    function toggleSub() {
      sub.classList.toggle('on');
      sub.setAttribute('aria-checked', sub.classList.contains('on') ? 'true' : 'false');
      renderPrices();
    }
    sub.addEventListener('click', toggleSub);
    sub.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        toggleSub();
      }
    });

    atc.addEventListener('click', function () {
      if (atc.disabled) return;
      var o = selectedOpt();
      if (!o) return;
      var variantId = parseInt(o.getAttribute('data-variant-id'), 10);
      var planId = parseInt(o.getAttribute('data-plan-id'), 10);
      if (!variantId) return;

      var payload = { items: [{ id: variantId, quantity: 1 }] };
      if (sub.classList.contains('on') && planId) {
        payload.items[0].selling_plan = planId;
      }

      var original = atc.textContent;
      atc.disabled = true;
      atc.textContent = 'ADDING…';

      fetch((window.Shopify && Shopify.routes && Shopify.routes.root ? Shopify.routes.root : '/') + 'cart/add.js', {
        method: 'POST',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(payload)
      })
        .then(function (r) {
          if (!r.ok) return r.json().then(function (err) {
            throw err;
          });
          return r.json();
        })
        .then(function (added) {
          atc.textContent = '✓ ADDED';
          /* Fetch full cart so HB drawer can render immediately (no empty flash). */
          var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
          return fetch(root + 'cart.js', { headers: { Accept: 'application/json' } })
            .then(function (r) { return r.json(); })
            .catch(function () {
              return { item_count: 1, items: [] };
            })
            .then(function (cart) {
              /* HB drawer listens for cart:change / variant:add and opens with this cart. */
              document.documentElement.dispatchEvent(
                new CustomEvent('cart:change', {
                  bubbles: true,
                  detail: { baseEvent: 'variant:add', cart: cart }
                })
              );
              return added;
            });
        })
        .then(function () {
          setTimeout(function () {
            atc.disabled = false;
            atc.textContent = original;
          }, 900);
        })
        .catch(function (err) {
          console.error('[hb-sub01]', err);
          atc.disabled = false;
          atc.textContent = original;
          var msg =
            (err && (err.description || err.message)) ||
            'Could not add to cart. Please try again.';
          alert(msg);
        });
    });

    refreshCadence();
    renderPrices();
  }

  function boot() {
    document.querySelectorAll('[data-hb-sub01]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
